import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'cit-app';
  constructor(private authService: AuthService){}

  ngOnInit(): void {
    window.addEventListener('storage', (event)=>{
      console.log("LocalStorage changed !!!!")
      const accessToken = event.storageArea.getItem("access-token");
      if (!accessToken || accessToken==undefined) {
        this.authService.logout();
      }
    })
  }
}
